import { Col, Row } from 'antd';
import { FormattedMessage } from 'react-intl';
import React, { useMemo } from 'react';
import styles from './CategoryPanelHeader.module.scss';
import { AssetEntity, AssetType } from 'src/modules/assets';

export interface CategoryPanelHeaderProps {
  categoryKey: string;
  assets: AssetEntity[];
}

export const CategoryPanelHeader = ({ categoryKey, assets = [] }: CategoryPanelHeaderProps) => {
  const extensions = useMemo(() => {
    return (
      assets
        // create array of extensions from array of assets
        .reduce((extensionList, asset) => {
          const currentExtension = (asset.type === AssetType.CAD
            ? asset.subtype
            : asset.file?.ext.slice(1)
          )?.toUpperCase();

          if (!extensionList.includes(currentExtension)) {
            extensionList.push(currentExtension);
          }

          return extensionList;
        }, [])
        .join(', ')
    );
  }, [assets]);
  return (
    <Row className={styles.row}>
      <Col md={12} sm={24} xs={24}>
        <FormattedMessage id={`products/downloads/listing/file_category/${categoryKey}`} />
      </Col>
      <Col md={12} sm={0} xs={0}>
        {extensions}
      </Col>
    </Row>
  );
};
